export const INT_CAR_BOOKING_WIDGET = "HOMEQBOMCAR";
export const INT_FLIGHT_BOOKING_WIDGET = "HOMEQBOMAIR";
export const INT_LFC_BOOKING_WIDGET = "HOME-BOOKING-WIDGET-LFC-AIR";
export const INT_RECENT_SEARCH = "RECENT-SEARCH-MDL";
